import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
import { saveQueryString } from '../../features/queryString/queryString-slice';

export function useRedirectToLandingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { queryString } = useSelector((state: RootState) => state);

  const handleRedirectToLandingPage = () => {
    dispatch(
      saveQueryString({
        journeyid: ''
      })
    );
    if (queryString.scheduleLandingPage) {
      navigate(`${queryString.scheduleLandingPage}`);
    } else {
      navigate('/selecao-de-servicos');
    }
  };

  return { handleRedirectToLandingPage };
}
